var React = require('react');
var ReactNative = require('react-native');

const Icon = require('./wrappers/ReUpIcon');

var Globals = require('./Globals');
var ModelConstants = require('./constants/ModelConstants.js');
var ReUpScrollView = require('./ReUpScrollView.js');
var ReUpButton = require('./ReUpButton.js');
var ShadowView = require('./ShadowView.js');
var ReUpText = require('./ReUpText');
var ReUpIconButton = require('./ReUpIconButton');
var LinkingManager = require('./wrappers/LinkingManager');

var Share = require('./wrappers/react-native-share-wrapper');

var MK = require('./wrappers/react-native-material-kit-wrapper');
var {
  MKButton
} = MK;

var {
  View,
  StyleSheet,
  Clipboard,
} = ReactNative;

var ReferAFriend = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      appManager : null,
    }
  },

  getInitialState : function()
  {
    return {
      layout : this.props.initialLayout,
      referCampaign : null,
      shouldShowFacebook : false,
      shouldShowTwitter : false,
    }
  },

  componentDidMount : function()
  {
    var thisThing = this;
    LinkingManager.canOpenURL("fb://feed",(shouldShowFacebook)=>
    {
      if( shouldShowFacebook ) thisThing.setState({shouldShowFacebook});
    })

    LinkingManager.canOpenURL("twitter://timeline",(shouldShowFacebook)=>
    {
      if( shouldShowFacebook ) thisThing.setState({shouldShowFacebook});
    })
  },

  didUpdate : function(data)
  {
    if( typeof data.Campaigns !== 'undefined' )
    {
      var referCampaign = null;
      for( var i = 0; i < data.Campaigns.length; i++ )
      {
        var campaign = data.Campaigns[i];
        if( campaign.Type == "Referral" ) referCampaign = JSON.parse(campaign.CampaignBlob);
      }
      this.setState({
        campaigns:data.Campaigns,
        referCampaign:referCampaign,
      });
    }
  },

  _referEmail:"",
  _referFirstName:"",
  _referLastName:"",
  _referFullName:"",
  showRefer: function(type)
  {
    var appManager = this.props.appManager;
    var appActions = this.props.appActions;
    var locManager = this.props.appManager.getLocalizationManager();
    var user = appManager.currentUser();
    var pointsLocalized = typeof this.state.referCampaign.RefereePoints !== 'undefined' ? locManager.localizedPoints(this.state.referCampaign.RefereePoints) : this.state.referCampaign.RewardName;
    var referTitle = this.props.referTitle;
    var bundleID = appManager.getAppData()["Header"]["BundleID"];
    var link = bundleID.split('.')[2] + ".getreup.com";
    var body = "";
    if( typeof this.state.referCampaign.RefereePoints !== 'undefined' )
    {
      body =  locManager.localizedStringForKeyAndParams("REFERRAL_BODY", [pointsLocalized, appManager.appName, user.ReferralCode, link]);      
    }
    else
    {
      body = locManager.localizedStringForKeyAndParams("REFERRAL_SMS_BODY", [pointsLocalized, appManager.appName, user.ReferralCode, link], "Receive a %0% at %1%! Use referral code %2% to sign up. Download here: %3%");
    }
    var shareOptions = {
      title: referTitle,
      subject: locManager.localizedStringForKeyAndParams("REFERRAL_SUBJECT", [appManager.appName]),
      message: body
    };

    if( typeof type === 'undefined' ) Share.open(shareOptions);
    else
    {
      shareOptions.social = type;
      Share.shareSingle(shareOptions);
    }
  },

  render: function()
  {
    // if( this.state.referCampaign == null ) return null;

    var thisThing = this;
    var appManager = this.props.appManager;
    var locManager = this.props.appManager.getLocalizationManager();
    var sendEmailButton = locManager.localizedStringForKey("SEND_AN_EMAIL_BUTTON");
    var postOnFacebookButton = locManager.localizedStringForKey("POST_ON_FACEBOOK_BUTTON");
    var postOnTwitterButton = locManager.localizedStringForKey("POST_ON_TWITTER_BUTTON");
    var otherButton = locManager.localizedStringForKey("OTHER_BUTTON");
    var user = appManager.currentUser();
    if( user == null ) return null;

    var instructionColor = appManager.getColorForKey("InstructionColor");
    var instructionTitleColor = appManager.getColorForKey("InstructionTitleColor");
    var generalTitleColorLight = appManager.getColorForKey("GeneralTitleColor", .6);
    var generalColor = appManager.getColorForKey("GeneralColor");
    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
    var rippleColor = appManager.getColorForKey("ButtonPrimaryColor", 0.4);
    var buttonPrimaryColor = appManager.getColorForKey("ButtonPrimaryColor");
    var buttonPrimaryTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");

    var instructions = "";
    if( this.state.referCampaign != null )
    {
      if( typeof this.state.referCampaign.ReferrerPoints !== 'undefined' )
      {
        var pointsLocalized = locManager.localizedPoints(this.state.referCampaign.ReferrerPoints);
        instructions = locManager.localizedStringForKeyAndParams("EARN_POINTS_STATEMENT",[pointsLocalized]);
      }
      else if( typeof this.state.referCampaign.RewardName !== 'undefined' )
      {
        instructions = locManager.localizedStringForKeyAndParams("EARN_POINTS_STATEMENT",["one "+this.state.referCampaign.RewardName]);
      }
    }

    var referralCode = user.ReferralCode;

    return (
      <View style={styles.container}>
        { this.props.extras && this.props.extras.shouldHideActionBar ? null : <View style={styles.actionBarSpacer} />}
        <View style={{position:'absolute', left:0, right:0, top:0, bottom:0, backgroundColor: generalColor}} />
        <ReUpScrollView ref="ptr" bounces={true} responder={this} isEmpty={this.state.referCampaign == null}>
          <View style={{flexDirection:'row', backgroundColor:instructionColor}}>
            <View style={{padding:10, flex:1}}>
              <ReUpText appManager={appManager} style={{color:instructionTitleColor}}>
                {instructions}
              </ReUpText>
            </View>
            <ReUpIconButton type={3}
              appManager={appManager}
              featureData={this.props.featureData}
              appActions={this.props.appActions}
              />
          </View>
          <ShadowView layout={this.state.layout} appManager={appManager}/>
          <View style={{alignSelf:'stretch'}}>
            <MKButton key={"info"}
              backgroundColor={'transparent'}
              shadowRadius={2}
              shadowOffset={{width:0, height:2}}
              shadowOpacity={0.7}
              rippleColor={rippleColor}
              shadowColor={'transparent'}
              onPress={() => {
                Clipboard.setString(referralCode);
              }}
              style={{flexDirection:'row', marginVertical:20}}>
              <View style={{flex:1}} />
              <View style={{alignSelf:'center', flex:3 }}>
                <View style={{padding:15, alignSelf:'stretch', flex:1}}>
                  <View style={{alignSelf:'stretch', padding:12, justifyContent:'center', borderWidth:1, flex:1, borderStyle:'dashed', borderColor:generalTitleColorLight}}>
                    <View>
                      <ReUpText isTitle={true} appManager={appManager} style={{fontSize:20, alignSelf:'center', color:generalTitleColor}}>
                        {referralCode}
                      </ReUpText>
                    </View>
                  </View>
                  <View style={{position:'absolute', width:30, height:30, borderRadius:15, overflow:'hidden', alignItems:'center', justifyContent:'center', backgroundColor:buttonPrimaryColor, top:0, right:0}}>
                    <Icon name={"clipboard"} size={16} color={buttonPrimaryTitleColor} />
                  </View>
                </View>
              </View>
              <View style={{flex:1}} />
            </MKButton>
          </View>
          <ReUpButton onPress={()=>{thisThing.showRefer("email")}} style={{marginBottom:10, marginHorizontal:20}} appManager={appManager} text={sendEmailButton} />
          { this.state.shouldShowFacebook ? <ReUpButton isSecondary={true} onPress={()=>{thisThing.showRefer("facebook")}} style={{marginBottom:10, marginHorizontal:20}} appManager={appManager} text={postOnFacebookButton} /> : null }
          { this.state.shouldShowTwitter ? <ReUpButton isSecondary={true} onPress={()=>{thisThing.showRefer("twitter")}} style={{marginBottom:10, marginHorizontal:20}} appManager={appManager} text={postOnTwitterButton} /> : null }
          <ReUpButton isSecondary={true} onPress={()=>{thisThing.showRefer()}} style={{marginBottom:10, marginHorizontal:20}} appManager={appManager} text={otherButton} />
        </ReUpScrollView>
      </View>
    );
  }
});

var styles = StyleSheet.create({
  container:{
    flex: 1,
    alignItems: 'stretch',
    flexDirection: 'column',
  },
  actionBarSpacer: {
    height:Globals.ACTION_BAR_HEIGHT,
  },
});

ReferAFriend.dataDependencies = ["Users", "Campaigns"];

module.exports = ReferAFriend;



// WEBPACK FOOTER //
// ./src/ReferAFriend.js